import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer({ className = "" }) {
  return (
    <footer className={`py-10 sm:py-8 px-4 sm:px-6 pb-20 sm:pb-16 border-t border-[#E6E2DD] bg-[#FDFBF7] ${className}`}>
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-4 sm:gap-3 text-center">
        <Link 
          to="/"
          className="text-lg sm:text-xl font-light text-[#2D2A26] hover:text-[#A87C6D] transition-colors"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          the soft ritual
        </Link>
        <span className="text-xs sm:text-sm text-[#6E6A66] italic px-4">
          A space for feeling, not fixing.
        </span>
        <div className="flex items-center gap-8 sm:gap-6 mt-2 sm:mt-0">
          <Link 
            to="/about" 
            className="text-xs sm:text-sm text-[#6E6A66] hover:text-[#A87C6D] transition-colors"
          >
            About
          </Link>
          <Link 
            to="/terms" 
            className="text-xs sm:text-sm text-[#6E6A66] hover:text-[#A87C6D] transition-colors"
          >
            Terms & Care
          </Link>
          <a 
            href="https://instagram.com/the.soft.ritual" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#6E6A66] hover:text-[#A87C6D] transition-colors"
            aria-label="Follow us on Instagram"
          >
            <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
